import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../styles/GlobalStyles';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderWrapper = styled.div.attrs(props => ({
  fullScreen: undefined,
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${props => props.fullScreen ? '100vh' : '200px'};
`;

const Spinner = styled.div.attrs(props => ({
  size: undefined,
}))`
  border: 4px solid ${colors.secondary};
  border-top: 4px solid ${colors.primary};
  border-radius: 50%;
  width: ${props => props.size || '50px'};
  height: ${props => props.size || '50px'};
  animation: ${spin} 1s linear infinite;
`;

export const Loader = ({ fullScreen = false, size = '50px' }) => {
  return (
    <LoaderWrapper fullScreen={fullScreen}>
      <Spinner size={size} />
    </LoaderWrapper>
  );
};

